<template>
  <header class="app-header">
    <!-- 顶部语言选择栏 -->
    <div class="top-bar">
      <div class="top-bar-container">
        <div class="language-selector">
          <a href="http://hzydcn.hzyddzsw.com/" target="_blank">中文</a>
          <span class="separator">|</span>
          <a href="/">English</a>
          <span class="separator">|</span>
          <a href="#" @click="lianxi">Contact us</a>
        </div>
      </div>
    </div>

    <!-- 主导航区域 -->
    <div class="main-header">
      <div class="header-container">
        <!-- Logo区域 -->
        <div class="logo" @click="goToHome">
          <img
            src="../assets/1f6e15d359008b5fac46ca951e2d833e.png"
            alt="和治友德"
            class="logo-img"
          />
          <!-- <span class="logo-text" v-if="!logoImg">和治友德</span> -->
        </div>

        <!-- 导航菜单 - 桌面端 -->
        <nav class="main-nav" v-if="!isMobile">
          <ul class="nav-list">
            <li
              v-for="(item, index) in navItems"
              :key="index"
              @click="navigateTo(item.path, item.list)"
            >
              {{ item.name }}
            </li>
          </ul>
        </nav>

        <!-- 移动端菜单按钮 -->
        <div class="mobile-menu-btn" v-else @click="toggleMobileMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div
      class="mobile-menu"
      v-if="showMobileMenu"
      :class="{ 'menu-enter': showMobileMenu }"
    >
      <ul class="mobile-nav-list">
        <li
          v-for="(item, index) in navItems"
          :key="index"
          @click="navigateTo(item.path, item.list)"
          :class="{ active: currentRoute === item.path }"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  name: "AppHeader",
  data() {
    return {
      logoImg: "", // 可以在这里设置logo图片路径 require('@/assets/images/logo.png')
      navItems: [
        { path: "/", name: "Home" },
        {
          path: "/about?id=70&unit_id=1",
          name: "About us",
        },
        {
          path: "/news?id=16&unit_id=2",
          name: "News",
        },
        {
          path: "/news?id=11&unit_id=3",
          name: "Product",
        },
        {
          path: "/news?id=8&unit_id=4",
          name: "Responsibility",
        },
      ],
      showMobileMenu: false,
      isMobile: false,
      currentRoute: "",
      currentLang: "zh", // 默认中文
    };
  },
  watch: {
    // 监听路由变化
    $route(to) {
      this.currentRoute = to.path;
    },
  },
  mounted() {
    // 初始化路由
    this.currentRoute = this.$route.path;

    // 检测屏幕尺寸
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    //跳转客服
    lianxi(id) {
      this.$router.push({
        path: `/about?id=74&unit_id=1&show=0`, // 将id拼接到路由路径中
      });
    },

    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
      // 屏幕尺寸变化时关闭移动菜单
      if (this.isMobile) {
        this.showMobileMenu = false;
      }
    },
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
      // 可以在这里添加菜单切换的动画类
    },
    goToHome() {
      this.$router.push("/");
    },
    navigateTo(path, list) {
      console.log(path, list);
      this.$router.push({
        path: path, // 原路径
        // query: {
        //   list: list, // 将数组作为 query 参数传递（会自动序列化）
        // },
      });
      // 导航后关闭移动菜单
      if (this.isMobile) {
        this.showMobileMenu = false;
      }
    },
    changeLang(lang) {
      this.currentLang = lang;
      // 这里可以添加语言切换的逻辑
      console.log("切换到", lang, "语言");
    },
  },
};
</script>

<style scoped>
/* 顶部语言栏样式 */
.top-bar {
  background-color: #f5f0e6;
  padding: 8px 0;
}

.top-bar-container {
  max-width: 1170px;
  margin: 0 auto;
  padding: 0 20px;
}

.language-selector {
  text-align: right;
}

.language-selector a {
  color: #333;
  text-decoration: none;
  margin: 0 8px;
  font-size: 14px;
  transition: color 0.3s;
}

.language-selector a.active {
  color: #c69749;
  font-weight: bold;
}

.language-selector a:hover {
  color: #c69749;
}

.separator {
  color: #ccc;
}

.contact-link {
  color: #c69749 !important;
}

/* 主导航栏样式 */
.main-header {
  background-color: #fff;
}

.header-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}

.logo {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.logo-img {
  height: 60px;
}

.logo-text {
  font-size: 24px;
  font-weight: bold;
  color: #c69749;
}

.main-nav {
  flex: 1;
  margin-left: 50px;
  padding: 20px 0;
}

.nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: right;
}

.nav-list li {
  margin: 0 20px;
  font-size: 20px;
  cursor: pointer;
  position: relative;
  padding: 8px 0;
  color: #b9972e;
  transition: color 0.3s;
  font-weight: 700;
}

.nav-list li:hover {
  color: #c7b16e;
  background-color: transparent;
}

.nav-list li::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #c7b16e;
  transition: width 0.3s ease;
}

.nav-list li:hover::after,
.nav-list li.active::after {
  width: 100%;
}

.nav-list li.active {
  color: #c69749;
  font-weight: 700;
}

/* 移动端样式 */
.mobile-menu-btn {
  font-size: 24px;
  cursor: pointer;
  color: #333;
}

.mobile-menu {
  background-color: #fff;
  border-top: 1px solid #eee;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.05);
  transition: max-height 0.3s ease-out;
  overflow: hidden;
}

.menu-enter {
  animation: menuFadeIn 0.3s ease-out;
}

@keyframes menuFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mobile-nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.mobile-nav-list li {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.3s;
  color: #333;
}

.mobile-nav-list li:hover {
  background-color: #f9f9f9;
  color: #c69749;
}

.mobile-nav-list li.active {
  color: #c69749;
  font-weight: 500;
  background-color: #f9f9f9;
}

@media (max-width: 767px) {
  .header-container {
    height: 70px;
  }

  .logo-img {
    height: 50px;
  }

  .logo-text {
    font-size: 20px;
  }

  .top-bar {
    padding: 5px 0;
  }

  .language-selector a {
    font-size: 13px;
    margin: 0 5px;
  }
}
</style>
